import { CheckCircle2 } from "lucide-react";

/**
 * KeyTakeaways — a visually clean, semantic summary block placed near the top
 * of an article or treatment page. Each bullet is a self-contained, quotable
 * sentence so AI answer engines (ChatGPT, Perplexity, Gemini) can extract and
 * cite it independently.
 *
 * All text is rendered in the initial HTML — no JavaScript injection, tabs,
 * or accordions — so crawlers can read it without executing scripts.
 */
export interface TakeawayItem {
  /** A self-contained factual sentence. */
  text: string;
}

export const KeyTakeaways = ({
  items,
  heading = "Key Takeaways",
}: {
  items: TakeawayItem[];
  heading?: string;
}) => (
  <section className="py-6 sm:py-8" aria-labelledby="key-takeaways-heading">
    <div className="container-px mx-auto max-w-3xl px-4">
      <div className="rounded-2xl border-2 border-accent/20 bg-gradient-to-br from-accent/[0.05] to-transparent p-5 sm:p-6 shadow-soft">
        <h2
          id="key-takeaways-heading"
          className="font-headings text-lg font-bold text-primary sm:text-xl"
        >
          {heading}
        </h2>
        <ul className="mt-4 space-y-2.5">
          {items.map((item, idx) => (
            <li key={idx} className="flex items-start gap-2.5">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-accent" />
              <span className="text-sm text-foreground/85 leading-relaxed">
                {item.text}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default KeyTakeaways;
